/** Marca oficial enviada pelo escritório. O mesmo arquivo também é usado no favicon. */
export function Simbolo({ className = 'h-8 w-8', invertido = false }: { className?: string; invertido?: boolean }): JSX.Element {
  return (
    <img
      src="/eysadvogados_logo.jpg"
      className={`${className} rounded-sm object-cover ${invertido ? 'invert' : ''}`}
      alt="Eckermann & Santos"
    />
  );
}

export function Logotipo({ invertido = false }: { invertido?: boolean }): JSX.Element {
  return (
    <div className="flex items-center gap-2.5">
      <Simbolo className="h-8 w-8 rounded-sm" invertido={invertido} />
      <div className="leading-none">
        <p
          className={`font-display text-[13px] font-semibold tracking-wide ${invertido ? 'text-white' : 'text-tinta-preto'}`}
        >
          ECKERMANN & SANTOS
        </p>
        <p
          className={`mt-1 text-2xs uppercase tracking-[0.18em] ${invertido ? 'text-white/45' : 'text-tinta-medio'}`}
        >
          ADVOGADOS · WORKPLACE
        </p>
      </div>
    </div>
  );
}
